<template>
  <a
    :href="href"
    :target="target"
    class="flex-shrink-0 flex items-center border-b no-underline"
  >
    <div class="p-4 flex flex-1 items-center max-w-full">
      <NumImage
        class="mr-4"
        :main-loaded="!!result"
        :controller="result && result.controller"
        :result="result"
        :src="imageSrc"
        :url="imageUrl"
      />
      <div class="flex-1 last:mb-0 min-w-0">
        <div class="flex mb-1">
          <h3 class="flex-1 fs-4 min-w-0 mb-0 leading-tight">
            <SkeletonLine
              :val="result"
              v-slot:default="{ val }"
              class="truncate"
            >
              <slot name="header">{{
                val.description || val.description_default
              }}</slot>
            </SkeletonLine>
          </h3>
          <div
            class="flex items-center max-w-50 ml-auto pl-2"
            v-if="showDetail"
          >
            <p
              class="min-w-0 text-gray-600 mb-0 px-2 py-1 -mt-1 leading-tight text-sm bg-gray-200 rounded-md"
            >
              <SkeletonLine :val="result" class="truncate" v-slot:default>
                <slot name="detail"></slot>
              </SkeletonLine>
            </p>
          </div>
        </div>
        <p class="mb-1 text-gray-600">
          <SkeletonLine :val="result" v-slot:default="{ val }">
            <slot name="description">{{ displayValue(val) }}</slot>
          </SkeletonLine>
        </p>
      </div>
    </div>
    <div
      class="flex flex-shrink-0 items-center pr-4 text-gray-600"
      @click.prevent.stop="showModal"
      v-if="showInfoIcon"
    >
      <ion-icon name="information-circle-outline" class="fs-3 pt-4 pb-4 pl-4" />
    </div>
    <Modal
      @close="hideHours"
      v-if="modalVisible && result"
      :header="result && (result.description || result.description_default)"
    >
      <Address :result="result" v-if="result.method_type === 'address'" />
      <Gps :result="result" v-if="result.method_type === 'gps'" />
      <Hours
        :href="href"
        :result="result"
        v-else-if="result.hours && result.hours.days"
      />
    </Modal>
  </a>
</template>

<script>
import Address from "@/views/Home/Address";
import Gps from "@/views/Home/Gps";
import Hours from "@/views/Home/Hours";
import Modal from "@/views/Home/Modal";
import NumImage from "@/views/Home/NumImage";
import SkeletonLine from "@/components/SkeletonLine";

export default {
  name: "ResultCard",
  components: {
    Address,
    Gps,
    Hours,
    Modal,
    NumImage,
    SkeletonLine,
  },
  props: {
    asLink: {
      default: true,
      type: Boolean,
    },
    imageUrl: String,
    numUriString: String,
    result: Object,
  },
  data() {
    return {
      modalVisible: false,
    };
  },
  computed: {
    href() {
      if (!this.asLink) return null;
      return this.result?.action || null;
    },
    imageSrc() {
      return this.result?.icon;
    },
    showDetail() {
      return this.$slots.detail?.[0]?.text?.length;
    },
    showInfoIcon() {
      return (
        this.result?.hours?.days ||
        this.result?.method_type === "address" ||
        this.result?.method_type === "gps"
      );
    },
    target() {
      return this.href?.startsWith("http") ? "_blank" : null;
    },
  },
  methods: {
    displayValue(value) {
      return value?.value?.display || value?.value || "";
    },
    hideHours() {
      this.modalVisible = false;
    },
    showModal() {
      this.modalVisible = true;
    },
  },
};
</script>
